import { useState } from "react";
import { EmployeeRecordSettings } from "./customPropertyConfig";
import { MySwitch } from "../../shared/MySwitch";

type AppCustomPropertySettingsEmployeeRecordProps = {
    settings: EmployeeRecordSettings
    onChange: (settings: EmployeeRecordSettings) => void;
}

export const AppCustomPropertySettingsEmployeeRecord = ({settings, onChange} : AppCustomPropertySettingsEmployeeRecordProps) => {
    return (
        <div className="app-custom-property-settings-container">
            { }
        </div>
    )
}